import { useSearchParams } from "react-router-dom";

import { QUERY_PARAMS } from "@av/apps/recruitment/ats-common/routes/jobs/query-params";
import { LoggedoutLanguageSelector } from "@av/components/molecules/LoggedoutLanguageSelector";
import type { Locale } from "@av/components/organisms/type";

export function JobsLanguageSelector() {
  const [, setSearchParams] = useSearchParams();

  const handleLanguageChange = (locale: Locale) => {
    setSearchParams(
      (currentSearchParams) => {
        const nextSearchParams = new URLSearchParams(currentSearchParams);

        nextSearchParams.set(QUERY_PARAMS.locale, locale);
        nextSearchParams.sort();

        return nextSearchParams;
      },
      // Keep the job board's record of where this entry came from
      { replace: true, state: window.history.state?.usr }
    );
  };

  return <LoggedoutLanguageSelector onLanguageChange={handleLanguageChange} />;
}
